import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Role } from '~app/shared/enums/role.enum';
import { StoreService } from '~app/shared/services/store/store.service';

@Injectable({
  providedIn: 'root',
})
export class IsRoleGuard {
  constructor(private readonly store: StoreService, private readonly router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const userRole = this.store.currentUser.role;
    const expectedRole: Array<Role> = route.data.roles;
    if (expectedRole.includes(userRole)) return true;
    this.router.navigate(['/']);
    return false;
  }
}
